import { defineField, defineType } from 'sanity'

import getPageInfo, { seoGroup } from '../../objects/pageInfo'
import { strongEmLink } from '../../../data/richText'

export default defineType({
  title: 'Sprint Line',
  name: 'sprintLine',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Hero Title',
      name: 'heroTitle',
      type: 'array',
      of: strongEmLink,
      group: 'content',
    }),
    defineField({
      title: 'Blue Box',
      name: 'blueBox',
      type: 'blueCTA',
      group: 'content',
    }),
    defineField({
      title: 'Overview',
      name: 'overview',
      type: 'lineOverview',
      group: 'content',
    }),
    getPageInfo({ lockCanonical: true }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})